/*
*	GDPR
*/
jQuery(document).ready(function($) {

	if ($.cookie('ikogdpr') == null) {
		$('#gdpr').delay(5000).fadeIn();

		$('#gdpr #ctaButton').click(function() {
			$.cookie('ikogdpr', 'accept', { expires: 60, path: '/' });
			$('#gdpr').fadeOut();
			// location.reload();
		});
	}

});